import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { WBSO } from 'src/app/core/constants/core.constant';
import { NUMBER } from 'src/app/core/enum/core.enum';
import { AuthService } from 'src/app/core/services/auth-service/auth.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-wbso-handbook',
    templateUrl: './wbso-handbook.component.html',
    styleUrls: ['./wbso-handbook.component.scss'],
    standalone: false
})
export class WbsoHandbookComponent implements OnInit {
  constants = WBSO;
  number = NUMBER;
  portalType: string;
  isAuthenticated: boolean = false;
  onTheLotCountryName: any;
  isBurbank: boolean = true;

  constructor(private readonly authService: AuthService,) {}


  ngOnInit(): void {
    this.checkAuthentication();
  }

  /**
 * checkAuthentication() - Asynchronously checks the user's authentication status.
 */
  private async checkAuthentication(): Promise<void> {
    this.isAuthenticated = await this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      const userProfileData = localStorage.getItem(this.constants.userProfile);
      if (userProfileData) {
        const userProfile = JSON.parse(userProfileData);
        this.setPortalType(userProfile);
        this.onTheLotCountryName = userProfile?.userPreferences?.onTheLotCountry?.onTheLotCountryName ?  userProfile.userPreferences?.onTheLotCountry?.onTheLotCountryName : '';
      }
    } else{
      this.onTheLotCountryName = this.constants.burbank;
    }
  }

  /**
 * setPortalType() - Sets the portalType property based on the userTypeId from the user profile.
 * @param userProfile - The user profile object containing userTypeId to determine portal type.
 */
  private setPortalType(userProfile: any): void {
    if (userProfile.userTypeId === 1) {
      this.portalType = this.constants.customer;
    } else if (userProfile.userTypeId === 2) {
      this.portalType = this.constants.studio;
    }
  }

  /**
 * toggleCity() - Toggles the value of the isBurbank property between true and false.
 */
  toggleCity(): void {
    this.isBurbank = !this.isBurbank;
  }
}
